import React from 'react';
import { renderRichText } from '../utils/rich-text';
import type { Form } from '../interfaces/form.interface';

interface CongratsMessageProps {
  configuration: Form;
}

export const CongratsMessage: React.FC<CongratsMessageProps> = ({ configuration }) => {
  return (
    <div 
      className="flex flex-col"
      style={{
        backgroundImage: configuration.theme?.visual?.background?.image ? `url(${configuration.theme?.visual?.background?.image})` : undefined,
        backgroundColor: configuration.theme?.visual?.background?.color || 'rgb(236, 169, 43)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
    >

      {/* Success Content */}
      <div className="flex-1 flex items-start justify-center px-4 mt-10">
        <div className="max-w-[600px] w-full text-center space-y-8">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div 
              className="w-16 h-16 rounded-full flex items-center justify-center"
              style={{ backgroundColor: configuration.theme?.buttons.style.background || '#10B981' }}
            >
              <svg 
                className="w-10 h-10 text-white" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M5 13l4 4L19 7" 
                />
              </svg>
            </div>
          </div>

          {/* Success Title */}
          <div>
            <h2 
              className="text-3xl font-bold mb-4"
              style={{ color: configuration.theme?.visual?.textColor || '#1F2937' }}
            >
              {configuration.theme?.content?.titles?.success || '¡Inscripción completada Exitosamente!'}
            </h2>
            
            {configuration.theme?.content?.subtitle && (
              <p 
                className="text-xl font-semibold"
                style={{ color: configuration.theme?.visual?.textColor || '#1F2937' }}
              >
                {renderRichText(configuration.theme?.content?.subtitle)}
              </p>
            )}
          </div>

          {/* Success Message */}
          <div className="space-y-4">
            {configuration.theme?.content?.paragraphs?.accept?.map((paragraph, index) => (
              <p 
                key={index} 
                className="text-lg leading-relaxed"
                style={{ color: configuration.theme?.visual?.textColor || '#374151' }}
              >
                {renderRichText(paragraph)}
              </p>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      {configuration.theme?.visual?.footer?.image && (
        <div className="w-full flex justify-center pb-8">
          <img 
            src={configuration.theme?.visual?.footer?.image}
            alt="Footer"
            style={{ 
              height: configuration.theme.visual.footer.height || 'auto',
              marginBottom: configuration.theme.visual.footer.marginBottom || 0
            }}
            className="max-w-full h-auto"
          />
        </div>
      )}
    </div>
  );
}; 